export default {"src":"/_next/static/image/public/images/ic_call_info.077048ef816fc7f407711aadced36ae2.svg","height":52,"width":52};